import { projectTourOntourSlice } from '../project-tour-ontour.slice';

export const clearTourTravels = projectTourOntourSlice.actions.clearTourTravels;
